import { motion } from "framer-motion";

export const PageHeader = ({ eyebrow, title, description, testId }) => (
  <header data-testid={testId} className="relative mx-auto max-w-5xl px-6 pt-36 pb-16 sm:pt-44 sm:pb-20">
    <div className="pointer-events-none absolute -top-24 right-0 h-72 w-72 rounded-full bg-gold/[0.07] blur-3xl" />
    <motion.p
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="font-mono text-xs uppercase tracking-[0.3em] text-gold"
    >
      {eyebrow}
    </motion.p>
    <div className="mt-4 overflow-hidden">
      <motion.h1
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        className="font-serif text-4xl sm:text-6xl font-light tracking-tight text-sand-bright"
      >
        {title}
      </motion.h1>
    </div>
    {description && (
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
        className="mt-6 max-w-2xl text-base sm:text-lg font-light leading-relaxed text-mist"
      >
        {description}
      </motion.p>
    )}
  </header>
);
